export const TRANSPARENT_PIXEL =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

export const AVATAR_COLORS = [
  '#ff9100',
  '#3d00fe',
  '#4caf50',
  '#ff005f',
  '#00897b',
  '#7c4dff',
]

export function avatarColorByName (name) {
  const str = String(name || '')
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) & 0x7fffffff
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}
